// LP Hero Product Form - Variant Selection & Price Update
console.log('🔥 LP HERO PRODUCT SCRIPT LOADED! 🔥');

// Store Flickity instance globally
let heroFlickity = null;

// Thumbnail navigation for carousel
function initThumbnailsAndCarousel() {
  console.log('LP Hero: initThumbnailsAndCarousel called');
  const carousel = document.querySelector('.js-hero-slider');
  
  if (!carousel) {
    console.log('LP Hero: No carousel found');
    return;
  }
  
  console.log('LP Hero: Carousel found');
  
  // Wait for Flickity to be available
  if (typeof Flickity === 'undefined') {
    console.log('LP Hero: Flickity not loaded, retrying...');
    setTimeout(initThumbnailsAndCarousel, 100);
    return;
  }
  
  console.log('LP Hero: Flickity is available');
  
  // Try to get existing Flickity instance or create new one
  heroFlickity = Flickity.data(carousel);
  
  // If not initialized, manually initialize Flickity
  if (!heroFlickity) {
    try {
      console.log('LP Hero: Initializing new Flickity instance');
      heroFlickity = new Flickity(carousel, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: true,
        adaptiveHeight: false
      });
      console.log('LP Hero: Flickity initialized successfully');
    } catch (error) {
      console.error('LP Hero: Flickity init error:', error);
      setTimeout(initThumbnailsAndCarousel, 100);
      return;
    }
  } else {
    console.log('LP Hero: Using existing Flickity instance');
  }
  
  // Set up thumbnails
  setupThumbnails();
}

function setupThumbnails() {
  console.log('LP Hero: setupThumbnails called');
  const thumbnails = document.querySelectorAll('.js-hero-thumbnail');
  
  console.log('LP Hero: Found', thumbnails.length, 'thumbnails');
  
  if (thumbnails.length === 0 || !heroFlickity) {
    console.log('LP Hero: No thumbnails or no Flickity instance');
    return;
  }
  
  // Function to update active thumbnail
  function updateActiveThumbnail(index) {
    console.log('LP Hero: Updating active thumbnail to index', index);
    thumbnails.forEach((thumb, i) => {
      if (i === index) {
        thumb.classList.add('is-selected');
      } else {
        thumb.classList.remove('is-selected');
      }
    });
  }
  
  // Update thumbnail active state on carousel change
  heroFlickity.on('change', updateActiveThumbnail);
  console.log('LP Hero: Carousel change listener added');
  
  // Click handler for thumbnails
  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener('click', function(e) {
      console.log('LP Hero: Thumbnail', index, 'clicked!');
      e.preventDefault();
      e.stopPropagation();
      heroFlickity.select(index);
    });
  });
  
  console.log('LP Hero: Click handlers added to all thumbnails');
  
  // Set initial active state
  updateActiveThumbnail(0);
  console.log('LP Hero: Initial active state set');
}

function initLpHeroProduct() {
  console.log('LP Hero Product: Initializing...');
  const form = document.getElementById('lp-hero-product-form');
  
  // Initialize thumbnails regardless of form presence - with delay to ensure Flickity is loaded
  setTimeout(initThumbnailsAndCarousel, 500);
  
  // Only set up variant handlers if form exists
  if (!form) {
    console.log('LP Hero Product: No form found, skipping variant handlers');
    return;
  }
  
  console.log('LP Hero Product: Form found, setting up variant handlers');

  const variantButtons = form.querySelectorAll('.lp-variant-btn input[type="radio"]');
  const hiddenVariantInput = form.querySelector('input[name="id"]');
  const priceElement = form.querySelector('.lp-price');
  const comparePriceElement = form.querySelector('.lp-compare-price');
  const submitButton = form.querySelector('button[type="submit"]');

  // Variant selection handler
  variantButtons.forEach(radio => {
    radio.addEventListener('change', function() {
      const variantId = this.value;
      const variantData = getVariantData(variantId);
      
      if (variantData) {
        // Update hidden input
        hiddenVariantInput.value = variantId;
        
        // Update price
        if (priceElement) {
          priceElement.innerHTML = formatMoney(variantData.price);
        }
        
        // Update compare price
        if (comparePriceElement && variantData.compare_at_price > variantData.price) {
          comparePriceElement.innerHTML = formatMoney(variantData.compare_at_price);
          comparePriceElement.style.display = 'inline';
        } else if (comparePriceElement) {
          comparePriceElement.style.display = 'none';
        }
        
        // Update button state
        if (submitButton) {
          if (variantData.available) {
            submitButton.disabled = false;
            submitButton.textContent = submitButton.dataset.addText || 'In den Warenkorb';
          } else {
            submitButton.disabled = true;
            submitButton.textContent = 'Ausverkauft';
          }
        }
        
        // Update carousel image if variant has featured media
        if (variantData.featured_media_id && window.lpProductData.mediaById) {
          const mediaIndex = window.lpProductData.mediaById[variantData.featured_media_id];
          if (mediaIndex !== undefined) {
            updateCarouselImage(mediaIndex);
          }
        }
        
        // Update active state on labels
        variantButtons.forEach(r => {
          r.closest('.lp-variant-btn').classList.toggle('active', r === this);
        });
      }
    });
  });

  // Update carousel image to specific index
  function updateCarouselImage(index) {
    if (heroFlickity) {
      heroFlickity.select(index);
    } else {
      // Try to get instance if not stored yet
      const carousel = document.querySelector('.js-hero-slider');
      if (carousel) {
        heroFlickity = Flickity.data(carousel);
        if (heroFlickity) {
          heroFlickity.select(index);
        }
      }
    }
  }

  // Get variant data from data attributes or window object
  function getVariantData(variantId) {
    if (window.lpProductData && window.lpProductData.variants) {
      return window.lpProductData.variants.find(v => v.id == variantId);
    }
    return null;
  }

  // Format money using Shopify's money format
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme.moneyFormat || '{{amount_with_comma_separator}} €');
    }
    return (cents / 100).toFixed(2) + ' €';
  }
}

// Initialize - works with both defer and normal script loading
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLpHeroProduct);
} else {
  // DOM already loaded
  initLpHeroProduct();
}
